import { AxiosRequestConfig } from "axios";

export const postCreatePasswordConfig: AxiosRequestConfig = {
  method: "post",
  url: "/user/create-password",
  headers: {
    Accept: "*/*",
    "Content-Type": "application/json",
  },
};
